import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaEye, FaEyeSlash, FaCheck, FaTimes } from "react-icons/fa";
import { CountryList } from "../../utils/countrylist";

// const CountryList = [
//     {
//         isoCode: "tg",
//         name: "TOGO",
//         code: "+228",
//         digit: 8,
//         currency: "xof",
//         payments: [],
//     },
//     {
//         isoCode: "bj",
//         name: "BENIN",
//         code: "+229",
//         digit: 8,
//         currency: "xof",
//         payments: [],
//     },
//     {
//         isoCode: "cm",
//         name: "CAMEROON",
//         code: "+237",
//         digit: 9,
//         currency: "xaf",
//         payments: [],
//     },
//     {
//         isoCode: "sn",
//         name: "SENEGAL",
//         code: "+221",
//         digit: 9,
//         currency: "xof",
//         payments: [],
//     },
//     {
//         isoCode: "bf",
//         name: "BURKINA FASO",
//         code: "+226",
//         digit: 8,
//         currency: "xof",
//         payments: [],
//     },
//     {
//         isoCode: "ci",
//         name: "COTE D'IVOIRE",
//         code: "+225",
//         digit: 10,
//         currency: "xof",
//         payments: [],
//     },
//     {
//         isoCode: "ml",
//         name: "MALI",
//         code: "+223",
//         digit: 8,
//         currency: "xof",
//         payments: [],
//     },
// ];

const apiUrl = process.env.REACT_APP_CAPITALYA_API_URL;

// Fonction pour vérifier les critères du mot de passe
const checkPasswordCriteria = (password) => {
    return {
        minLength: password.length >= 8,
        hasUppercase: /[A-Z]/.test(password),
        hasLowercase: /[a-z]/.test(password),
        hasNumber: /[0-9]/.test(password),
        hasSpecialChar: /[!@#$%^&*(),.?":{}|<>_\-+=[\]\\/'`~]/.test(password)
    };
};

// Formulaire d'inscription
export const SignupForm = () => {
    const [formData, setFormData] = useState({
        firstname: "",
        lastname: "",
        email: "",
        password: "",
        passwordConfirm: "",
        country: "",
        tel: "",
        referrer: "",
        countryCode: ""
    });

    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [passwordCriteria, setPasswordCriteria] = useState({
        minLength: false,
        hasUppercase: false,
        hasLowercase: false,
        hasNumber: false,
        hasSpecialChar: false
    });

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const refCode = params.get("ref");
        if (refCode) {
            setFormData((prev) => ({ ...prev, referrer: refCode }));
        }
    }, [location]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

        // Mettre à jour les critères du mot de passe en temps réel
        if (name === "password") {
            setPasswordCriteria(checkPasswordCriteria(value));
        }

        // Effacer l'erreur du champ modifié
        if (errors[name]) {
            setErrors({ ...errors, [name]: "" });
        }
        if (apiError) {
            setApiError("");
        }
    };

    const handleTelChange = (e) => {
        const { value } = e.target;
        const selectedCountry = CountryList.find(c => c.isoCode === formData.country);

        // Ne garder que les chiffres
        const numericValue = value.replace(/\D/g, "");

        // Limiter selon le nombre de digits du pays
        if (selectedCountry) {
            const limitedValue = numericValue.slice(0, selectedCountry.digit);
            setFormData({ ...formData, tel: limitedValue });
        } else {
            setFormData({ ...formData, tel: numericValue });
        }

        // Effacer l'erreur
        if (errors.tel) {
            setErrors({ ...errors, tel: "" });
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.firstname.trim()) {
            newErrors.firstname = "Le prénom est requis";
        }

        if (!formData.lastname.trim()) {
            newErrors.lastname = "Le nom est requis";
        }

        if (!formData.email.trim()) {
            newErrors.email = "L'email est requis";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "L'email n'est pas valide";
        }

        if (!formData.password) {
            newErrors.password = "Le mot de passe est requis";
        } else {
            const criteria = checkPasswordCriteria(formData.password);
            if (!criteria.minLength || !criteria.hasUppercase || !criteria.hasLowercase || 
                !criteria.hasNumber || !criteria.hasSpecialChar) {
                newErrors.password = "Le mot de passe ne respecte pas tous les critères requis";
            }
        }

        if (!formData.passwordConfirm) {
            newErrors.passwordConfirm = "Veuillez confirmer votre mot de passe";
        } else if (formData.password !== formData.passwordConfirm) {
            newErrors.passwordConfirm = "Les mots de passe ne correspondent pas";
        }

        if (!formData.country) {
            newErrors.country = "Veuillez sélectionner un pays";
        }

        const selectedCountry = CountryList.find(c => c.isoCode === formData.country);
        if (!formData.tel) {
            newErrors.tel = "Le numéro de téléphone est requis";
        } else if (selectedCountry && formData.tel.length !== selectedCountry.digit) {
            newErrors.tel = `Le numéro doit contenir ${selectedCountry.digit} chiffres`;
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSignup = async (e) => {
        e.preventDefault();
        setApiError("");

        if (!validateForm()) {
            return;
        }

        const selectedCountry = CountryList.find(c => c.isoCode === formData.country);
        const countryCode = selectedCountry ? selectedCountry.code : "";

        const bodyToSend = {
            ...formData,
            tel: formData.tel,
            countryCode
        };

        setIsLoading(true);

        try {
            const res = await fetch(`${apiUrl}/api/auth/register`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(bodyToSend)
            });

            const data = await res.json();

            if (!res.ok) {
                setApiError(data.message || "Erreur lors de l'inscription. Veuillez réessayer.");
                setIsLoading(false);
                return;
            }

            localStorage.setItem("token", data.token);
            navigate("/auth/login");
        } catch (err) {
            console.error(err);
            setApiError("Erreur de connexion au serveur. Veuillez réessayer.");
            setIsLoading(false);
        }
    };

    const selectedCountry = CountryList.find(c => c.isoCode === formData.country);
    const selectedPhoneCode = selectedCountry ? selectedCountry.code : "";
    const maxDigits = selectedCountry ? selectedCountry.digit : 15;

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Bandeau supérieur mobile uniquement */}
            <div className="lg:hidden w-full h-24 bg-gradient-to-r from-blue-500 to-purple-600 text-white flex justify-start items-center gap-6 text-2xl font-bold pl-10 md:text-3xl">
                <img src="/logo-capitalya.jpeg" alt="capitalya" className="size-20 rounded-full" />
                <p>CAPITALYA</p>
            </div>

            {/* Modal de chargement */}
            {isLoading && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-8 max-w-sm mx-4 text-center shadow-2xl">
                        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-500 mx-auto mb-4"></div>
                        <h3 className="text-xl font-bold text-gray-800 mb-2">Inscription en cours</h3>
                        <p className="text-gray-600">Veuillez patientez...</p>
                    </div>
                </div>
            )}

            {/* Container principal */}
            <div className="lg:min-h-screen lg:flex lg:items-center lg:justify-center lg:p-8">
                <div className="lg:flex lg:max-w-6xl lg:w-full lg:shadow-2xl lg:rounded-2xl lg:overflow-hidden">

                    {/* Section dégradé gauche - Desktop uniquement */}
                    <div className="hidden lg:flex lg:flex-col lg:justify-center lg:items-center lg:w-1/2 bg-gradient-to-br from-blue-500 via-purple-600 to-blue-500 p-12 text-white">
                        <div className="space-y-6 text-center">
                            {/* Espace pour le logo */}
                            <div className="flex justify-center mb-8">
                                <div className="bg-white rounded-full p-6 shadow-2xl">
                                    <div className="w-24 h-24 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-4xl font-bold text-white">
                                        <img src="/logo-capitalya.jpeg" alt="capitalya" className="w-24 h-24 rounded-[50%]" />
                                    </div>
                                </div>
                            </div>

                            {/* Nom du site */}
                            <h1 className="text-5xl font-bold tracking-wider">
                                CAPITALYA
                            </h1>

                            <div className="space-y-4 mt-8">
                                <p className="text-xl font-medium">
                                    Rejoignez notre plateforme
                                </p>
                                <p className="text-lg opacity-90">
                                    Activez votre compte et commencez à générer des revenus
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Section formulaire */}
                    <div className="lg:w-1/2 bg-white">
                        <div className="flex items-center justify-center p-4 lg:p-12">
                            <div className="w-full max-w-md space-y-5">
                                <h2 className="text-2xl font-bold text-gray-800 text-center flex justify-center items-center">
                                    <p>Créez un compte</p>
                                </h2>

                                {/* Affichage de l'erreur API */}
                                {apiError && (
                                    <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                                        {apiError}
                                    </div>
                                )}

                                <form onSubmit={handleSignup} className="space-y-4">
                                    <div>
                                        <input
                                            type="text"
                                            name="lastname"
                                            placeholder="Nom"
                                            value={formData.lastname}
                                            onChange={handleChange}
                                            className={`w-full px-4 py-3 border rounded-lg text-sm focus:ring-2 focus:outline-none ${errors.lastname
                                                    ? "border-red-300 focus:ring-red-400"
                                                    : "border-gray-300 focus:ring-blue-400"
                                                }`}
                                        />
                                        {errors.lastname && (
                                            <p className="text-red-500 text-xs mt-1">{errors.lastname}</p>
                                        )}
                                    </div>

                                    <div>
                                        <input
                                            type="text"
                                            name="firstname"
                                            placeholder="Prénom"
                                            value={formData.firstname}
                                            onChange={handleChange}
                                            className={`w-full px-4 py-3 border rounded-lg text-sm focus:ring-2 focus:outline-none ${errors.firstname
                                                    ? "border-red-300 focus:ring-red-400"
                                                    : "border-gray-300 focus:ring-blue-400"
                                                }`}
                                        />
                                        {errors.firstname && (
                                            <p className="text-red-500 text-xs mt-1">{errors.firstname}</p>
                                        )}
                                    </div>

                                    <div>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Adresse email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            className={`w-full px-4 py-3 border rounded-lg text-sm focus:ring-2 focus:outline-none ${errors.email
                                                    ? "border-red-300 focus:ring-red-400"
                                                    : "border-gray-300 focus:ring-blue-400"
                                                }`}
                                        />
                                        {errors.email && (
                                            <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                                        )}
                                    </div>

                                    <div>
                                        <div className="relative">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                name="password"
                                                placeholder="Mot de passe"
                                                value={formData.password}
                                                onChange={handleChange}
                                                className={`w-full px-4 py-3 border rounded-lg text-sm focus:ring-2 focus:outline-none ${errors.password
                                                        ? "border-red-300 focus:ring-red-400"
                                                        : "border-gray-300 focus:ring-blue-400"
                                                    }`}
                                            />
                                            <span
                                                onClick={() => setShowPassword(!showPassword)}
                                                className="absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500"
                                            >
                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                            </span>
                                        </div>
                                        
                                        {/* Critères du mot de passe */}
                                        <div className="mt-2 space-y-1 bg-gray-50 p-3 rounded-lg">
                                            <p className="text-xs font-semibold text-gray-700 mb-2">Le mot de passe doit contenir :</p>
                                            <div className="flex items-center gap-2 text-xs">
                                                {passwordCriteria.minLength ? (
                                                    <FaCheck className="text-green-500 flex-shrink-0" />
                                                ) : (
                                                    <FaTimes className="text-red-500 flex-shrink-0" />
                                                )}
                                                <span className={passwordCriteria.minLength ? "text-green-600 font-medium" : "text-gray-600"}>
                                                    Au moins 8 caractères
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-2 text-xs">
                                                {passwordCriteria.hasUppercase ? (
                                                    <FaCheck className="text-green-500 flex-shrink-0" />
                                                ) : (
                                                    <FaTimes className="text-red-500 flex-shrink-0" />
                                                )}
                                                <span className={passwordCriteria.hasUppercase ? "text-green-600 font-medium" : "text-gray-600"}>
                                                    Au moins 1 majuscule (A-Z)
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-2 text-xs">
                                                {passwordCriteria.hasLowercase ? (
                                                    <FaCheck className="text-green-500 flex-shrink-0" />
                                                ) : (
                                                    <FaTimes className="text-red-500 flex-shrink-0" />
                                                )}
                                                <span className={passwordCriteria.hasLowercase ? "text-green-600 font-medium" : "text-gray-600"}>
                                                    Au moins 1 minuscule (a-z)
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-2 text-xs">
                                                {passwordCriteria.hasNumber ? (
                                                    <FaCheck className="text-green-500 flex-shrink-0" />
                                                ) : (
                                                    <FaTimes className="text-red-500 flex-shrink-0" />
                                                )}
                                                <span className={passwordCriteria.hasNumber ? "text-green-600 font-medium" : "text-gray-600"}>
                                                    Au moins 1 chiffre (0-9)
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-2 text-xs">
                                                {passwordCriteria.hasSpecialChar ? (
                                                    <FaCheck className="text-green-500 flex-shrink-0" />
                                                ) : (
                                                    <FaTimes className="text-red-500 flex-shrink-0" />
                                                )}
                                                <span className={passwordCriteria.hasSpecialChar ? "text-green-600 font-medium" : "text-gray-600"}>
                                                    Au moins 1 caractère spécial (!@#$%...)
                                                </span>
                                            </div>
                                        </div>
                                        
                                        {errors.password && (
                                            <p className="text-red-500 text-xs mt-1">{errors.password}</p>
                                        )}
                                    </div>

                                    <div>
                                        <div className="relative">
                                            <input
                                                type={showPasswordConfirm ? "text" : "password"}
                                                name="passwordConfirm"
                                                placeholder="Confirmez votre mot de passe"
                                                value={formData.passwordConfirm}
                                                onChange={handleChange}
                                                className={`w-full px-4 py-3 border rounded-lg text-sm focus:ring-2 focus:outline-none ${errors.passwordConfirm
                                                        ? "border-red-300 focus:ring-red-400"
                                                        : "border-gray-300 focus:ring-blue-400"
                                                    }`}
                                            />
                                            <span
                                                onClick={() => setShowPasswordConfirm(!showPasswordConfirm)}
                                                className="absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500"
                                            >
                                                {showPasswordConfirm ? <FaEyeSlash /> : <FaEye />}
                                            </span>
                                        </div>
                                        {errors.passwordConfirm && (
                                            <p className="text-red-500 text-xs mt-1">{errors.passwordConfirm}</p>
                                        )}
                                    </div>

                                    <div>
                                        <select
                                            name="country"
                                            value={formData.country}
                                            onChange={handleChange}
                                            className={`w-full px-4 py-3 border rounded-lg text-sm focus:ring-2 focus:outline-none ${errors.country
                                                    ? "border-red-300 focus:ring-red-400"
                                                    : "border-gray-300 focus:ring-blue-400"
                                                }`}
                                        >
                                            <option value="">Sélectionnez un pays</option>
                                            {CountryList.map((country) => (
                                                <option key={country.isoCode} value={country.isoCode}>
                                                    {country.name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.country && (
                                            <p className="text-red-500 text-xs mt-1">{errors.country}</p>
                                        )}
                                    </div>

                                    <div>
                                        <div className="flex gap-2">
                                            <input
                                                type="text"
                                                disabled
                                                value={selectedPhoneCode}
                                                className="w-16 sm:w-20 px-2 sm:px-3 py-3 border border-gray-300 rounded-lg text-sm bg-gray-100 text-center flex-shrink-0"
                                                placeholder="+000"
                                            />

                                            <input
                                                type="text"
                                                name="tel"
                                                placeholder={`Numéro (${maxDigits} chiffres)`}
                                                value={formData.tel}
                                                onChange={handleTelChange}
                                                className={`flex-1 min-w-0 px-4 py-3 border rounded-lg text-sm focus:ring-2 focus:outline-none ${errors.tel
                                                        ? "border-red-300 focus:ring-red-400"
                                                        : "border-gray-300 focus:ring-blue-400"
                                                    }`}
                                            />
                                        </div>
                                        {errors.tel && (
                                            <p className="text-red-500 text-xs mt-1">{errors.tel}</p>
                                        )}
                                        {formData.country && formData.tel && (
                                            <p className="text-gray-500 text-xs mt-1">
                                                {formData.tel.length}/{maxDigits} chiffres
                                            </p>
                                        )}
                                    </div>

                                    <input
                                        disabled={true}
                                        type="text"
                                        name="referrer"
                                        placeholder="Code parrain (optionnel)"
                                        value={formData.referrer}
                                        onChange={handleChange}
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg text-sm bg-gray-100"
                                    />

                                    <button
                                        type="submit"
                                        disabled={isLoading}
                                        className={`w-full py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg font-semibold transition ${isLoading
                                                ? "opacity-60 cursor-not-allowed"
                                                : "hover:opacity-90"
                                            }`}
                                    >
                                        {isLoading ? "⏳ Inscription en cours..." : "🚀 S'inscrire"}
                                    </button>
                                </form>

                                <p className="text-sm text-center text-gray-600">
                                    Déjà inscrit ?{" "}
                                    <button
                                        onClick={() => navigate("/auth/login")}
                                        className="text-blue-500 font-medium hover:underline"
                                    >
                                        Se connecter
                                    </button>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Formulaire de connexion
export const LoginForm = () => {
    const [credentials, setCredentials] = useState({ email: "", password: "" });
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const [apiError, setApiError] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_CAPITALYA_API_URL;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials({ ...credentials, [name]: value });

        // Effacer l'erreur du champ modifié
        if (errors[name]) {
            setErrors({ ...errors, [name]: "" });
        }
        if (apiError) {
            setApiError("");
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!credentials.email.trim()) {
            newErrors.email = "L'email est requis";
        } else if (!/\S+@\S+\.\S+/.test(credentials.email)) {
            newErrors.email = "L'email n'est pas valide";
        }

        if (!credentials.password) {
            newErrors.password = "Le mot de passe est requis";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setApiError("");

        if (!validateForm()) {
            return;
        }

        setIsLoading(true);

        try {
            const res = await fetch(`${apiUrl}/api/auth/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(credentials)
            });
            const data = await res.json();

            if (!res.ok) {
                setApiError(data.message || "Erreur lors de la connexion. Veuillez vérifier vos identifiants.");
                setIsLoading(false);
                return;
            }

            localStorage.setItem("token", data.token);
            localStorage.setItem("user", JSON.stringify(data.user));

            navigate("/dashboard");
        } catch (err) {
            console.error(err);
            setApiError("Erreur de connexion au serveur. Veuillez réessayer.");
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Bandeau supérieur mobile uniquement */}
            <div className="lg:hidden w-full h-24 bg-gradient-to-r from-blue-500 to-purple-600 text-white flex justify-start items-center gap-6 text-2xl font-bold pl-10 md:text-3xl">
                <img src="/logo-capitalya.jpeg" alt="capitalya" className="size-20 rounded-full" />
                <p>CAPITALYA</p>
            </div>

            {/* Modal de chargement */}
            {isLoading && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-8 max-w-sm mx-4 text-center shadow-2xl">
                        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-purple-500 mx-auto mb-4"></div>
                        <h3 className="text-xl font-bold text-gray-800 mb-2">Connexion en cours</h3>
                        <p className="text-gray-600">Veuillez patientez...</p>
                    </div>
                </div>
            )}

            {/* Container principal */}
            <div className="lg:min-h-screen lg:flex lg:items-center lg:justify-center lg:p-8">
                <div className="lg:flex lg:max-w-6xl lg:w-full lg:shadow-2xl lg:rounded-2xl lg:overflow-hidden">

                    {/* Section dégradé gauche - Desktop uniquement */}
                    <div className="hidden lg:flex lg:flex-col lg:justify-center lg:items-center lg:w-1/2 bg-gradient-to-br from-purple-600 via-blue-500 to-purple-600 p-12 text-white">
                        <div className="space-y-6 text-center">
                            {/* Espace pour le logo */}
                            <div className="flex justify-center mb-8">
                                <div className="bg-white rounded-full p-6 shadow-2xl">
                                    <div className="w-24 h-24 bg-gradient-to-br from-purple-600 to-blue-500 rounded-full flex items-center justify-center text-4xl font-bold text-white">
                                        <img src="/logo-capitalya.jpeg" alt="capitalya" className="w-24 h-24 rounded-[50%]" />
                                    </div>
                                </div>
                            </div>

                            {/* Nom du site */}
                            <h1 className="text-5xl font-bold tracking-wider">
                                CAPITALYA
                            </h1>

                            <div className="space-y-4 mt-8">
                                <p className="text-xl font-medium">
                                    Bon retour parmi nous !
                                </p>
                                <p className="text-lg opacity-90">
                                    Connectez-vous pour accéder à votre tableau de bord
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Section formulaire */}
                    <div className="lg:w-1/2 bg-white">
                        <div className="flex items-center justify-center p-4 lg:p-12">
                            <div className="w-full max-w-md space-y-5">
                                <h2 className="text-2xl font-bold text-gray-800 text-center">
                                    🔐 Connexion
                                </h2>

                                {/* Affichage de l'erreur API */}
                                {apiError && (
                                    <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                                        {apiError}
                                    </div>
                                )}

                                <form onSubmit={handleLogin} className="space-y-4">
                                    <div>
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Adresse email"
                                            value={credentials.email}
                                            onChange={handleChange}
                                            className={`w-full px-4 py-3 border rounded-lg text-sm focus:ring-2 focus:outline-none ${errors.email
                                                    ? "border-red-300 focus:ring-red-400"
                                                    : "border-gray-300 focus:ring-blue-400"
                                                }`}
                                        />
                                        {errors.email && (
                                            <p className="text-red-500 text-xs mt-1">{errors.email}</p>
                                        )}
                                    </div>

                                    <div>
                                        <div className="relative">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                name="password"
                                                placeholder="Mot de passe"
                                                value={credentials.password}
                                                onChange={handleChange}
                                                className={`w-full px-4 py-3 border rounded-lg text-sm focus:ring-2 focus:outline-none ${errors.password
                                                        ? "border-red-300 focus:ring-red-400"
                                                        : "border-gray-300 focus:ring-blue-400"
                                                    }`}
                                            />
                                            <span
                                                onClick={() => setShowPassword(!showPassword)}
                                                className="absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500"
                                            >
                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                            </span>
                                        </div>
                                        {errors.password && (
                                            <p className="text-red-500 text-xs mt-1">{errors.password}</p>
                                        )}
                                    </div>

                                    <button
                                        type="submit"
                                        disabled={isLoading}
                                        className={`w-full py-3 bg-gradient-to-r from-purple-600 to-blue-500 text-white rounded-lg font-semibold transition ${isLoading
                                                ? "opacity-60 cursor-not-allowed"
                                                : "hover:opacity-90"
                                            }`}
                                    >
                                        {isLoading ? "⏳ Connexion en cours..." : "✅ Se connecter"}
                                    </button>
                                </form>

                                <p className="text-sm text-center text-gray-600">
                                    Pas encore de compte ?{" "}
                                    <button
                                        onClick={() => navigate("/auth/signup")}
                                        className="text-purple-500 font-medium hover:underline"
                                    >
                                        S'inscrire
                                    </button>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};